export enum AuthErrorTypes {
    NoMatchingState = 'NoMatchingState',
    ClockSkewErrorFuture = 'ClockSkewErrorFuture',
    ClockSkewErrorPast = 'ClockSkewErrorPast',
    Other = 'Other'
}

export const WEB_VIEW = 'webView';